<template>
    <div class="formation beneficial-owner-index">
        <b-button
            v-if="beneficialOwnersList.beneficialOwnersDropdownList.length <= 0"
            variant="primary"
            class="d-flex justify-content-cener align-items-center"
            @click="openCreateBeneficialOwnerForm"
        >
            <vector
                data-name="add-user"
                data-width="15px"
                data-height="12px"
                data-test="add-a-new-beneficial-owner-btn"
                class="mr-.5 d-flex justify-content-center align-items-center"
            />
            Add a new Beneficial Owner
        </b-button>

        <b-dropdown
            v-else
            id="dropdown-1"
            class="mt-.3"
            variant="primary"
            data-test="addBeneficialOwner"
        >
            <template #button-content>
                <div
                    class="
                        d-inline-flex
                        justify-content-center
                        align-items-center
                        text-wrap
                    "
                >
                    <vector
                        data-name="add-user"
                        data-width="15px"
                        data-height="12px"
                        class="
                            mr-.5
                            d-flex
                            justify-content-center
                            align-items-center
                        "
                    />
                    Add another Beneficial Owner
                </div>
            </template>

            <b-dropdown-item
                style="font-size: 1.2em"
                variant="primary"
                data-test="addNewBeneficialOwnerManually"
                @click="openCreateBeneficialOwnerForm"
            >
                Add a new Beneficial Owner manually
            </b-dropdown-item>

            <div v-if="beneficialOwnersList.beneficialOwnersDropdownList && beneficialOwnersList.beneficialOwnersDropdownList.length >= 1">
                <div class="dropdown-divider"></div>

                <b-dropdown-text class="text-ternary">
                    <span> Select one from the list </span>
                </b-dropdown-text>

                <b-dropdown-item
                    v-for="beneficialOwner in beneficialOwnersList.beneficialOwnersDropdownList"
                    :key="beneficialOwner.name + '_' + beneficialOwner.email"
                    class="text-primary text-uppercase"
                    variant="primary"
                    style="font-size: 1.2em"
                    :data-test="`beneficialOwner-${beneficialOwner.email}`"
                    @click="$emit('createBeneficialOwnerFromDropdown', beneficialOwner)"
                >
                    {{ beneficialOwner.name }}
                </b-dropdown-item>
            </div>

        </b-dropdown>

        <loader v-if="isFetchingData" data-type="MinimumTaskList" class="mt-1 custom-loading" />

        <div v-if="beneficialOwnersList.beneficialOwners && ! isFetchingData">
            <div
            v-for="beneficialOwner in beneficialOwnersList.beneficialOwners"
            :key="beneficialOwner.name"
            class="mt-2"
            >
                <div
                    data-test="list-box"
                    class="list-box mb-1 row align-items-center"
                    style="margin-left: 0.1em; margin-right: 0.1em"
                >
                    <div
                        class="
                            user
                            d-flex
                            align-items-center
                            col-lg-4
                            justify-content-lg-start justify-content-md-center
                            mb-md-0 mb-sm-1
                        "
                    >

                        <b-avatar
                            size="30"
                            :text="getAvatarInitial(beneficialOwner.name)"
                            :variant="`light-primary`"
                        />

                        <h3 class="font-weight-bold p-0 m-0 ml-1 text-break">
                            {{ beneficialOwner.name }}
                        </h3>
                    </div>

                    <p
                        class="
                            m-0
                            p-0
                            col-lg-5
                            text-right
                            align-items-center
                            text-sm-center
                            mb-md-0 mb-sm-1
                            text-lg-right
                        "
                    >
                        {{ beneficialOwner.email }}                        
                    </p> 
    
                    <div
                        data-test="actions"
                        class="
                            actions
                            mb-md-0
                            d-flex
                            justify-content-md-end
                            align-items-center
                            col-lg-3
                            justify-content-sm-center
                        "
                    >
                        <span                        
                        :class="['steps-status d-block mr-2', getCompletedStepsOf(beneficialOwner) === getTotalStepsOf(beneficialOwner) ? 'text-success' : 'text-danger']
                        ">
                            {{ getCompletedStepsOf(beneficialOwner) }} / {{ getTotalStepsOf(beneficialOwner) }}
                        </span>
                        
                        <div
                            class="mr-2 cursor-pointer"
                            :data-test="`edit-${beneficialOwner.name}`"
                            @click="$emit('edit', beneficialOwner, 'edit')"
                        >
                            <feather-icon size="21" icon="EditIcon" />
                        </div>

                        <div class="cursor-pointer">
                            <vector
                                data-type="icon"
                                data-name="cancel"
                                :data-test="`delete-${beneficialOwner.name}`"
                                @click.native="$emit('remove', beneficialOwner)"
                            ></vector>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {
    BDropdown,
    BDropdownItem,
    BDropdownText,
    BAvatar,
    BButton
} from "bootstrap-vue";

export default {
    components: {
        BDropdown,
        BDropdownItem,
        BDropdownText,
        BAvatar,
        BButton
    },

    props: {
        beneficialOwnersList: {
            type: Object,
            required: true,
        },

        beneficialOwnerBluePrint: {
            type: Object,
            required: true,
        },

        isFetchingData: {
            type: Boolean,
            required: true
        }
    },

    methods: {
        openCreateBeneficialOwnerForm(beneficialOwner = this.beneficialOwnerBluePrint) {
            this.$emit("createBeneficialOwner", beneficialOwner);
        },

        getCompletedStepsOf(beneficialOwner) {
            return Object.keys(this.beneficialOwnerBluePrint).filter(
                key => !!beneficialOwner[key] && !key.includes('dateOfExpiry') && !key.includes('otherSource')
            ).length - (beneficialOwner.sourcesOfFunds.length >= 1 ? 1 : 2);
        },

        // ignore,dob, otherSource
        getTotalStepsOf() {
            return Object.keys(this.beneficialOwnerBluePrint).length - (2 + 1);
        },
    },
};
</script>
